import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { CostProfileCostsHistory } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  editCost(request: Boundaries["editCost"]["request"]): void;
}

function useEditCost(cost: CostProfileCostsHistory[number]): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isEditCostRequestPending(cost),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isEditCostRequestSuccess(cost),
    ),
    isRequestFailure: useSelector(() =>
      selector.isEditCostRequestFailure(cost),
    ),
    editCost: core.editCost,
  };
}

export { useEditCost };
